import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg组件

// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
// 递归加载 svg 目录及其子目录下的所有 svg 文件
const req = require.context('./svg', true, /\.svg$/)
requireAll(req)



// WEBPACK FOOTER //
// ./src/icons/index.js